import * as apiLib from './api';

export const login = async ({ loginType, loginId, loginPw }) => {
  try {
    const data = {
      loginType: loginType,
      loginId: loginId,
      loginPw: loginPw,
    };

    const result = await apiLib.fetchApi('/auth/create-token', data);
    if (result.resultFlag) {
      localStorage.setItem('accessToken', result.accessToken);
      return result.loginInfo;
    } else {
      throw Object.assign(new Error('login error'), { status: 401 });
    }
  } catch (err) {
    throw err;
  }
};

export const confirmToken = async ({ accessToken }) => {
  try {
    const data = {
      accessToken,
    };

    const result = await apiLib.fetchApi('/auth/confirm-token', data);
    if (result.resultFlag) {
      localStorage.setItem('accessToken', result.accessToken);
      return result.loginInfo;
    } else {
      throw Object.assign(new Error('confirm token error'), { status: 401 });
    }
  } catch (err) {
    throw err;
  }
};

export const ssoToken = async ({ accessToken, loginId }) => {
  try {
    const data = {
      accessToken,
      loginId,
    };

    const result = await apiLib.fetchApi('/auth/sso-token', data);
    if (result.resultFlag) {
      localStorage.setItem('accessToken', result.accessToken);
      return result.loginInfo;
    } else {
      throw Object.assign(new Error('sso token error'), { status: 401 });
    }
  } catch (err) {
    throw err;
  }
};
